import { useEffect, useState } from "react";
import { TransportCompany } from "../interface/api/TransportCompany";
import { TransportTicketFields } from "../interface/api/TransportTicketFields";
import { Truck } from "../interface/api/Truck";
import transportCompanyService from "../services/transportCompanyService";
import truckService from "../services/truckService";

export function useTransportCascade<T extends TransportTicketFields>({
  ticket,
  setTicket,
}: {
  ticket: T | null;
  setTicket: React.Dispatch<React.SetStateAction<T | null>>;
}) {
  const [transportCompanies, setTransportCompanies] = useState<
    { value: number; label: string }[]
  >([]);
  const [trucks, setTrucks] = useState<Truck[]>([]);

  useEffect(() => {
    transportCompanyService.getTransportCompanies().then((response) => {
      if (response.ok && response.data) {
        const companies = response.data as TransportCompany[];
        setTransportCompanies(
          companies.map((c) => ({ value: c.id, label: c.name }))
        );
      }
    });
  }, []);

  useEffect(() => {
    if (ticket?.transportCompanyId) {
      truckService
        .getTrucks({
          transportCompanyId: ticket.transportCompanyId,
          truck: null,
          transportContact: null,
        })
        .then((response) => {
          if (response.ok && response.data) {
            setTrucks(response.data as Truck[]);
          }
        });
    } else {
      setTrucks([]);
    }
  }, [ticket?.transportCompanyId]);

  const onTransportCompanyChange = (option: any) => {
    if (option) {
      setTicket((prev) =>
        prev
          ? {
              ...prev,
              transportCompanyId: option.value,
              transportCompanyName: option.label,
              haulageCompanyName: option.label,
              truckId: null,
              truckNumber: null,
              truckLicensePlate: null,
              truckDriverName: null,
            }
          : prev
      );
    } else {
      setTicket((prev) =>
        prev
          ? {
              ...prev,
              transportCompanyId: null,
              transportCompanyName: null,
              haulageCompanyName: null,
              truckId: null,
              truckNumber: null,
              truckLicensePlate: null,
              truckDriverName: null,
            }
          : prev
      );
    }
  };

  const onTruckChange = (e: React.ChangeEvent<{ value: unknown }>) => {
    const truckId = Number(e.target.value);
    const selectedTruck = trucks.find((t) => t.id === truckId);
    if (selectedTruck) {
      setTicket((prev) =>
        prev
          ? {
              ...prev,
              truckId: selectedTruck.id,
              truckNumber: selectedTruck.number,
              truckLicensePlate:
                selectedTruck.licensePlate || prev.truckLicensePlate,
              truckDriverName:
                selectedTruck.driverName || prev.truckDriverName,
            }
          : prev
      );
    } else {
      setTicket((prev) =>
        prev
          ? {
              ...prev,
              truckId: null,
              truckNumber: null,
              truckLicensePlate: null,
              truckDriverName: null,
            }
          : prev
      );
    }
  };

  return { transportCompanies, trucks, onTransportCompanyChange, onTruckChange };
}
